/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Outlet } from "react-router-dom";
import Sidebar from '../components/_Sidebar';
import { ToastContainer } from 'react-toastify';
import { withParamsAndNavigate } from '../components/WithParamsAndNavigate';
import { PopModal } from '../components/PopModal';
import { Modal } from 'react-bootstrap';
import Icon from '../components/Icon';
import SandboxModal from '../components/SandboxModal';
import ChatBubble from '../components/chat/ChatBubble';
import BaseCom from '../components/BaseCom';
import { HTMLEditorModal } from '../components/HTMLEditorModal';
import { ImageGalleryOverlay } from '../components/ImageGalleryOverlay';
import AIPretty from '../components/AI';
import { ProcessingModal } from '../components/ProcessingModal';
import { PDFModal } from '../components/PDFModal';
import { ErrorAlertModal } from '../components/ErrorAlertModal';
import Tick from '../components/Tick';
import { qreq } from "../shared/qrequest";
import L from "../components/Lang";
import '../css/style.css';

import Globals from "../shared/Globals";
import ClientLayout from "./ClientLayout";
import Auth from "../shared/Auth";

class Portal extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            this.setState({ user: this.props.user });
    }

    onSidebarToggle = (on) => {
        this.setState({ sidebarToggle: on });
    }

    tick = async () => {
        if (this.state.ticking) return;
        this.setState({ ticking: true });
        if (this.state.location !== window.location.pathname) {
            const info = { location: window.location.pathname };
            try {
                let j = await qreq.postAsync('/api/auth/location/set', info);
                if (j.errorCode === 0)
                    this.setState({ location: window.location.pathname });
            }
            catch (e) {
                console.error(e);
            }
        }
        this.setState({ ticking: false });
    }

    render() {

        // Client Layout when /client
        if (document.location.pathname.startsWith('/client') || Auth.hasPolicy('patient'))
            return <ClientLayout />

        return (
            <>
                <SandboxModal />
                <ToastContainer position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light" />
                <PopModal />
                <PDFModal />
                <ImageGalleryOverlay />
                <HTMLEditorModal />
                <AIPretty />
                <ProcessingModal />
                <ErrorAlertModal />
                <Tick onTick={this.tick} />
                <Modal show={this.props.showConnError}>
                    <Modal.Header>
                        <Modal.Title><Icon icon="faTriangleExclamation" /><L>Connection Error</L></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p><L>Could not connect to the server. Will try to reconnect...this modal will automatically disappear once re-connected.</L></p>
                    </Modal.Body>
                </Modal>
                <main className={this.state.sidebarToggle ? 'main-nav-open' : 'main-nav-close'}>
                    <Sidebar user={this.state.user} navigate={this.props.navigate} onSidebarToggle={this.onSidebarToggle} />
                    <ChatBubble />
                    <div className="c-pagewrapper">
                        <div>
                            <Outlet />
                        </div>
                        {/*<div className="c-footer text-center">
                            <a href="https://udhs.net/privacy-policy.html" target="_blank" rel="noreferrer">Privacy Policy</a> | <a href="https://udhs.net/terms-of-service.html" target="_blank" rel="noreferrer">Terms of Service</a>
                        </div>*/}
                    </div>
                </main>
            </>
        );
    }
}

export default withParamsAndNavigate(Portal);
